<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 15 15"
  >
    <g>
      <path
        :fill="color"
        d="M6.94 9.222h4.627v4.627H6.94zm-5.785 0h4.628v4.627H1.155zM2.89 7.147v.918h-.918zm8.098-1.058L9.832 7.246V3.098l1.156-1.157zM4.047 8.065V3.44h4.628v4.626zm7.859 0h-1.258l1.157-1.156h1.258zm1.974 3.809l-1.156 1.157V8.883l1.156-1.156zM6.023 1.124h4.147L9.013 2.28H4.865zM.576 15.004h11.57a.573.573 0 0 0 .409-.17l2.312-2.313a.573.573 0 0 0 .17-.41V6.33a.58.58 0 0 0-.578-.578h-2.314V.544a.58.58 0 0 0-.578-.578H5.783c-.028 0-.051.012-.079.015-.047.007-.096.01-.14.029a.578.578 0 0 0-.191.127L3.06 2.45a.573.573 0 0 0-.17.41V5.75a.573.573 0 0 0-.41.17L.168 8.234a.573.573 0 0 0-.17.406v5.787c0 .32.259.578.578.578z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B2A8C1',
    },
    size: {
      type: Number,
      default: 15,
    },
  },
};
</script>
